import {useNuxtApp} from '#app'
import {formatDimensions} from '~/assets/js/utils/format_dimensions'

export const useDimensionFormatter = () => {
  const nuxtApp = useNuxtApp()
  const locale = nuxtApp.$i18n?.locale?.value || 'en'

  const formatRangeDimension = (
    activeValues: any,
    unitOfMeasure?: string,
    localizedUnitOfMeasure?: string
  ): string => {
    if (!activeValues) {
      return '-'
    }

    let from = activeValues.from ?? activeValues.start
    let endVal = activeValues.end
    const tolerance = activeValues.tolerance

    if (from === null || from === undefined) {
      return '-'
    }

    const displayAsInch = localizedUnitOfMeasure === 'inch' || unitOfMeasure === 'inch'

    if (unitOfMeasure === 'mm' && localizedUnitOfMeasure === 'inch') {
      from = from / 25.4
      if (endVal !== null && endVal !== undefined) {
        endVal = endVal / 25.4
      }
    }

    const formattedFrom = formatDimensions(from, locale, displayAsInch, true)
    const toleranceStr = tolerance ? ` ~ ${tolerance}` : ''
    const endStr = endVal !== null && endVal !== undefined ? ` - ${formatDimensions(endVal, locale, displayAsInch, true)}` : ''

    return `${formattedFrom}${toleranceStr}${endStr}`.trim()
  }

  return {
    formatRangeDimension
  }
}
